import { render } from "./ShowBhavaTable.vue?vue&type=template&id=f17cef68&scoped=true"
import script from "./ShowBhavaTable.vue?vue&type=script&lang=js"
export * from "./ShowBhavaTable.vue?vue&type=script&lang=js"

import "./ShowBhavaTable.vue?vue&type=style&index=0&id=f17cef68&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f17cef68"]])

export default __exports__